import React from 'react';
import { useExperiments } from 'components/Experiment/useExperiments';
import SiteHeader from 'components/SiteHeader';
import SiteHeaderNew from 'components/SiteHeaderNew';
import UnconnectedSiteHeader from 'components/SiteHeader/SiteHeader';
import UnconnectedSiteHeaderNew from 'components/SiteHeaderNew/SiteHeader';
import { EOS_NEW_HEADER } from 'constants/monetateExperiments';

const SiteHeaderDecisioner = (props: React.JSX.IntrinsicAttributes & object) => {
  const { getDecisionById } = useExperiments();
  const showNewHeader =
    getDecisionById(EOS_NEW_HEADER.experiment).variant === EOS_NEW_HEADER.variant.showNewHeader;

  return showNewHeader ? <SiteHeaderNew {...props} /> : <SiteHeader {...props} />;
};
const SiteHeaderWrapper = (
  props: React.JSX.IntrinsicAttributes & {
    decisions?: { [key: string]: string };
    isHomepage?: boolean;
    ssrRender?: boolean;
  },
) => {
  const { decisions, ssrRender } = props;
  if (ssrRender) {
    return decisions?.EoS_newHeader === 'showNewHeader' ? (
      <UnconnectedSiteHeaderNew {...props} />
    ) : (
      <UnconnectedSiteHeader {...props} />
    );
  }
  return <SiteHeaderDecisioner {...props} />;
};

SiteHeaderWrapper.displayName = 'SiteHeaderWrapper';

export default SiteHeaderWrapper;
